var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-more"},[_vm._v(" Les mer om "),_c('a',{staticClass:"read-more__link",attrs:{"href":_vm.link}},[_vm._v("Forbrukerrådets kommunetest")])])}
var staticRenderFns = []

export { render, staticRenderFns }